module.exports = __webpack_public_path__ + "img/download-qr.5a954b91.png";